import { render, staticRenderFns } from "./SettingView.vue?vue&type=template&id=67108e7a&scoped=true"
import script from "./SettingView.vue?vue&type=script&lang=js"
export * from "./SettingView.vue?vue&type=script&lang=js"
import style0 from "./SettingView.vue?vue&type=style&index=0&id=67108e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67108e7a",
  null
  
)

export default component.exports